import React from 'react';
import Linkify from 'linkifyjs/react';
import { bool, string } from 'prop-types';

import cx from 'classnames';
import s from './Message.css';


// Renders both the user and provider speech bubbles conditionally
const Message = ({ dateTimeSent, fromPatient, message, userName }) => {

    // Message sent by the viewer, add different style
    const fromPatientCss = fromPatient ? s.fromPatient : '';
    const emptyMessageCss = message.length === 0 ? s.emptyMessage : '';
    const linkifyOptions = {
        attributes: {
            rel: 'noopener noreferrer'
        },
    }
    return (
        <article className={cx(s.component, fromPatientCss, emptyMessageCss)}>
            <div className={s.flexColumn}>
                {fromPatient &&
                    <div className={cx(s.flex, s.timeStamp, fromPatientCss)}>
                        <p className={s.sender}>
                            {dateTimeSent}
                        </p>
                        <p>You</p>
                    </div>
                }
                {!fromPatient &&
                    <div className={cx(s.flex, s.timeStamp)}>
                        <p className={s.sender}>
                            {userName}
                        </p>
                        <p>{dateTimeSent}</p>
                    </div>
                }
                {message.length > 0 &&
                    <div className={s.flex}>
                        <div className={cx(s.speechBubble, fromPatientCss)}>
                            <p className={s.body}>
                                <Linkify options={linkifyOptions}>{message}</Linkify>
                            </p>
                        </div>
                    </div>
                }
            </div>
        </article>
    );

};

/**
 * fromPatient and userName are set in the <Chat /> replyHandler()
 * @type message: object, fromPatient: boolean, userName: string
 */
Message.propTypes = {
    fromPatient: bool,
    message: string.isRequired,
    userName: string,
};

export default Message;